export const ANIMATION_DURATION = 300;

export const SIDEBAR_EL = document.getElementById('sidebar');

export const SUB_MENU_ELS = document.querySelectorAll(
  '.menu > ul > .menu-item.sub-menu'
);

export const FIRST_SUB_MENUS_BTN = document.querySelectorAll(
  '.menu > ul > .menu-item.sub-menu > a'
);

export const INNER_SUB_MENUS_BTN = document.querySelectorAll(
  '.menu > ul > .menu-item.sub-menu .menu-item.sub-menu > a'
);
